var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33398 9.991C5.33398 7.61648 5.33398 6.42838 6.07203 5.69117C6.80924 4.95313 7.99734 4.95312 10.3719 4.95312H12.8908C15.2653 4.95312 16.4534 4.95313 17.1906 5.69117C17.9287 6.42838 17.9287 7.61648 17.9287 9.991V14.1892C17.9287 16.5637 17.9287 17.7518 17.1906 18.4891C16.4534 19.2271 15.2653 19.2271 12.8908 19.2271H10.3719C7.99734 19.2271 6.80924 19.2271 6.07203 18.4891C5.33398 17.7518 5.33398 16.5637 5.33398 14.1892V9.991Z",
    stroke: "#454545",
    strokeWidth: 1.25947
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33339 16.7085C4.66533 16.7085 4.02462 16.4432 3.55223 15.9708C3.07984 15.4984 2.81445 14.8577 2.81445 14.1896V9.15173C2.81445 5.98543 2.81445 4.40186 3.79852 3.41863C4.78258 2.43541 6.36531 2.43457 9.53162 2.43457H12.8902C13.5583 2.43457 14.199 2.69996 14.6714 3.17235C15.1437 3.64474 15.4091 4.28544 15.4091 4.95351",
    stroke: "#454545",
    strokeWidth: 1.25947
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copyIcon.d91d7653f69f8faf1fd5bd56c8fc5b08.svg";
export { ForwardRef as ReactComponent };